// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3-cNe","fixed":"styles_fixed__15jW9","scroll":"styles_scroll__XdlRs","cell":"styles_cell__2DVyg","last-child":"styles_last-child__3T5Nm"};